
const Footer = () => {
  return (
    <footer>
          <div className="w3-container w3-text-grey">
    <p>
      Powered by{" "}
      <a href="https://www.w3schools.com/w3css/default.asp" target="_blank">
        w3.css
      </a>
    </p>
  </div>
    </footer>
  )
}

export default Footer